export default function PreVisitNotes({value, onChange}) {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-xl font-bold text-[#04395b] mb-2">Pre-Visit Notes</h2>
      <ul className="mb-2 text-sm text-gray-700 list-disc list-inside">
              <li>What symptoms have you noticed recently?</li>
              <li>Any questions you want to ask your doctor?</li>
              <li>How have you been feeling overall?</li>
            </ul>
      <textarea className="w-full mt-1 border rounded p-2" rows={3} placeholder="Type your notes here!" value={value} onChange={(e) => onChange(e.target.value)}/>
    </div>
  );
}
